import Anchor from 'components/typography/anchor';
import PropTypes from 'prop-types';
import { DATA_TYPES } from 'siteconfig';
import { CampaignTypeList } from 'utilities/propTypes';

const DriveRollup = ({
  driveRollup,
  // NOTE: This must start with a `/` or the link element will treat it as external and break the link
  linkPath,
  type = DATA_TYPES.CANDIDATE,
}) => {
  let subText;
  let title;
  let count;
  let countLabel;
  let stateCode;
  let link; // This might turn into a helper fn or something. Or jsut require caller to supply it

  switch (type) {
    case DATA_TYPES.CANDIDATE:
      subText = driveRollup.officeName;
      title = driveRollup.candidateName;
      count = driveRollup.signCount.toLocaleString();
      countLabel = 'pledges';
      link = linkPath;
      stateCode = driveRollup.stateCode.toLowerCase();
      break;
    default:
      throw new Error(`Unknown content type specified: ${type}`);
  }

  return (
    <div className="text-left">
      <Anchor
        className="animate-fadeIn relative m-4 mx-auto flex flex-row flex-wrap gap-2 gap-x-4 rounded p-4 text-gray-800 shadow-md hover:text-gray-800 dark:text-gray-100 dark:hover:border-blue-500 dark:hover:text-gray-100"
        href={link}
      >
        <div className={`sf-${stateCode}`} />
        <div className="flex-basis-[375px] flex flex-grow flex-col gap-1">
          <p className="m-0 text-base font-[650] -tracking-[0.01em] tracking-tight text-gray-800 dark:text-gray-100">
            {title}
          </p>
          <p className="text-xs font-semibold tracking-wider uppercase">
            Running <em>for</em> {subText}
          </p>
        </div>

        <div className="flex gap-4 text-base leading-normal">
          <div>
            <p className="font-bold">{count}</p>
            <p className="text-xs font-semibold tracking-wider uppercase">
              {countLabel}
            </p>
          </div>
        </div>
      </Anchor>
    </div>
  );
};

DriveRollup.propTypes = {
  campaign: CampaignTypeList,
  type: PropTypes.oneOf(Object.values(DATA_TYPES)),
};

export { DriveRollup };
